const Settings = require('../../../utils/AutoDetectSettings');

/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class BarsParser {

    static parseLaunch(launcherConfig) {
        return {
            basePath: `${launcherConfig.cdn}bars-next/`,
            assetsPath: '',
            options: {}
        };
    }

    static parse(cfg, settings, options) {
        cfg.bars.namespace = cfg.game.namespace;
        cfg.bars.timestamp = cfg.bridge.timestamp;
        cfg.bars.options.hasTurboMode = Boolean(cfg.bars.options.hasTurboMode);
        cfg.bars.gameType = cfg.game.preconfig.gameType;
        cfg.bars.options.hasExtras = Settings.hasExtras;
        cfg.bars.options.totalStake = options.isTable;
        if (options.isRTG) {
            // this will enable new bars preloader for all enviroments and operators unless operator config does not disable it!
            cfg.bars.options.hasPreloader = true;
        }

        if (cfg.bars.options.hasSlideUp === undefined) {
            cfg.bars.options.hasSlideUp = true;
        }

        if (options.urlParams['inApp'] || options.urlParams['inapp']) {
            cfg.bars.options.inApp = true;
        }
        if (cfg.bars.options.inApp) {
            cfg.bars.options.hasSlideUp = false;
            cfg.bars.options.fullScreen = false;
        }

        if (!cfg.bars.assetsPath) {
            cfg.bars.assetsPath = `${cfg.game.preconfig.cdn}../../assets/`;
        }

        if (options.urlParams['assetsPath']) {
            cfg.bars.assetsPath = options.urlParams['assetsPath'];
        }

        if (!cfg.bars.localizationsPath) {
            cfg.bars.localizationsPath = `${cfg.game.preconfig.cdn}../../localizations/`;
        }

        cfg.bars.provider = cfg.bridge.provider;

        let session = {};
        if (settings && settings.user) {
            session = {
                sessionCode: settings.user.aamsSessionId,
                participationCode: settings.user.aamsParticipationId,
                balanceCash: settings.user.balance.cash,
                balanceSession: settings.user.balance.session,
                maxDeposit: settings.user.maxDeposit,
                depositedAmount: settings.user.depositedAmount
            };

            if (cfg.bridge.providerParams && cfg.bridge.providerParams.hasSessionBalance===true) {
                cfg.bars.isLegacy = true; // Force for Italy
            }

            if (settings.user.autoplay !== undefined) {
                cfg.bars.options.autoplay = settings.user.autoplay;
            }

            if (cfg.gamble && cfg.gamble.enabled) {
                const abTestOperators = ['kindred', 'skillonnet', 'mrgreen', 'casinobet'];

                if (abTestOperators.includes(cfg.bridge.operator) && !options.abTest.generate({ chance: 50 })) {
                    console.log('[bridge] - AB tests for gamble activated');

                    cfg.bars.options.hasGambleNext = true;
                }
            }

        }
        if (settings && settings.game){
            cfg.bars.options.hasFeatureBuy = Boolean(settings.game.hasFeatureBuy);
        }

        cfg.bars.session = session;

        switch (cfg.game.preconfig.gameAppId) {
        case 'NFTMegaWays':
            cfg.bars.skin = 'nftmegaways';

        }

        return cfg.bars;
    }


}


module.exports = BarsParser;
